<template>
  <el-collapse class="info-line-items-collapse" v-model="openedTabs">
    <el-collapse-item
      :title="$t('myLoads.myLoadsDetail.loadDetails')"
      name="lineItems"
    >
    <InfoLineItems
    v-if="selectedLineItems"
    :selectedLineItems="selectedLineItems"
    :loadById="loadById"
    :isDrayage="isDrayage"
    />
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import InfoLineItems from "../../../components/LineItems.vue";

export default {
  name: "InfoLineItemsResponsive",
  props: {
    loadById: Object,
  },
  components: {
    InfoLineItems,
  },
  data() {
    return {
      selectedLineItems: null,
      openedTabs: ["lineItems"],
    };
  },
  computed: {
    isDrayage() {
      return this.loadById?.mode_name?.toLowerCase() === 'drayage';
    },
  },
  async created() {
    this.selectedLineItems = this.loadById.line_items;
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/_variables' as *;
@use '@/assets/scss/_themes' as *;
@use '@/assets/scss/_mixin' as *;
.info-line-items-collapse {
  border: none;
}
::v-deep {
  .el-collapse-item__wrap {
    border: none;
  }
  .el-collapse-item__header {
    background-color: $color-background;
    font-family: $font-family-portal;
    color: $color-primary-company;
    @include font-standart-text;
    width: 100%;
    display: flex;
    font-weight: bold;
    justify-content: space-between;
    padding: 0% 7%;
    border: none;
  }
  .el-collapse-item__content {
    background-color: $color-background;
    font-family: $font-family-portal;
    @include font-small-standart-text;
    padding-bottom: 1%;
  }
  .row-accessorials__information {
    margin-left: 10px;
  }
  .el-icon-arrow-right:before {
    padding: 10px;
    color: $color-primary-company;
    font-weight: bold;
  }
  .el-icon-arrow-right:after {
    padding: 10px;
    color: $color-primary-company;
    font-weight: bold;
  }
}
</style>
